import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
export function PriceAlertV2() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [isExpired, setIsExpired] = useState(false);
  useEffect(() => {
    // Target date: April 11, 2025 11:59 PM
    const targetDate = new Date('2025-04-11T23:59:59').getTime();
    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = targetDate - now;
      if (distance < 0) {
        setIsExpired(true);
        return;
      }
      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    };
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);
  return <motion.div initial={{
    y: -100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="sticky top-0 z-50 w-full overflow-hidden" data-id="element-471">
      {/* Main Banner */}
      <div className="relative bg-gradient-to-r from-gold-dark via-gold to-gold-light shadow-2xl" data-id="element-472">
        {/* Animated shine effect */}
        <motion.div animate={{
        x: ['-100%', '200%']
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'linear',
        repeatDelay: 1
      }} className="absolute inset-0 w-1/3 bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-12" data-id="element-473" />

        {/* Content Container */}
        <div className="relative py-3 md:py-4 px-4" data-id="element-474">
          <div className="max-w-7xl mx-auto" data-id="element-475">
            <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4" data-id="element-476">
              <div className="flex items-center gap-2 md:gap-3" data-id="element-477">
                <motion.div animate={{
                scale: [1, 1.15, 1]
              }} transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="flex-shrink-0" data-id="element-478">
                  <div className="relative" data-id="element-479">
                    <div className="absolute inset-0 bg-navy/20 rounded-full blur-md" data-id="element-480" />
                    <AlertCircleIcon className="relative h-5 w-5 md:h-6 md:w-6 text-navy" aria-hidden="true" data-id="element-481" />
                  </div>
                </motion.div>

                <p className="font-heading font-black text-sm md:text-lg text-navy leading-tight text-center" data-id="element-482">
                  <span className="hidden md:inline" data-id="element-483">⚡ </span>
                  Sin saber diseño. Sin gastar en publicidad.
                </p>
              </div>

              {!isExpired && <div className="flex items-center gap-1.5 md:gap-2" data-id="element-484">
                  <div className="bg-navy text-gold font-heading font-black text-xs md:text-sm px-2 py-1 rounded" data-id="element-485">
                    {timeLeft.days}d
                  </div>
                  <span className="text-navy font-black" data-id="element-486">:</span>
                  <div className="bg-navy text-gold font-heading font-black text-xs md:text-sm px-2 py-1 rounded" data-id="element-487">
                    {timeLeft.hours.toString().padStart(2, '0')}h
                  </div>
                  <span className="text-navy font-black" data-id="element-488">:</span>
                  <div className="bg-navy text-gold font-heading font-black text-xs md:text-sm px-2 py-1 rounded" data-id="element-489">
                    {timeLeft.minutes.toString().padStart(2, '0')}m
                  </div>
                  <span className="text-navy font-black" data-id="element-490">:</span>
                  <div className="bg-navy text-gold font-heading font-black text-xs md:text-sm px-2 py-1 rounded w-[36px] md:w-[42px] text-center" data-id="element-491">
                    {timeLeft.seconds.toString().padStart(2, '0')}s
                  </div>
                </div>}

              {/* removed mobile-only duplicate text */}
            </div>
          </div>
        </div>

        {/* Bottom decorative border */}
        <div className="h-1 bg-gradient-to-r from-navy-dark via-navy to-navy-dark" data-id="element-492" />
      </div>
    </motion.div>;
}